import React from 'react';
import '../components/DBOSHomepage.css';
import SiteHeader from '../components/SiteHeader';

const Resources = () => {
  return (
    <div className="solution-page">
      <SiteHeader active="news" />

      <main className="solution-content">
        <div className="container">
          <section className="hero-section">
            <img src="/assets/img/DBOS-logo-s-z.jpg" alt="DBOS" className="news-hero-logo" />
            <h1 className="page-title">News &amp; Events</h1>
            <p className="page-subtitle">Updates from DBOS, and where to meet us next.</p>
          </section>

          <section className="content-section">
            <h2>Upcoming Events</h2>

            <div className="event-card">
              <div className="event-date">Thursday, 20 August - 19:00 Dublin (GMT+1)</div>
              <h3>DBOS Partner &amp; Friends Meetup #2</h3>
              <p>Online, via Google Meet.</p>
              <p><strong>Agenda:</strong></p>
              <ul>
                <li>Welcome</li>
                <li>News &amp; Media Update</li>
                <li>Technology Update</li>
                <li>Customer Success &amp; Support</li>
                <li>Partner Onboarding</li>
              </ul>
              <p>This event is all about helping you become successful and grow with DBOS, and add value to your local community. Every local business owner, tech shop, repair service, and VAR is welcome, as well as anyone interested in DBOS World.</p>
              <a href="https://luma.com/iqfylgj2" target="_blank" rel="noopener noreferrer" className="btn-primary">Register on Luma</a>
            </div>

            <div className="event-card">
              <div className="event-date">Thursday, 17 September - 19:00 Dublin (GMT+1)</div>
              <h3>DBOS Partner &amp; Friends Meetup #3</h3>
              <p>Online, via Google Meet.</p>
              <p><strong>Agenda:</strong></p>
              <ul>
                <li>Welcome</li>
                <li>News &amp; Media Update</li>
                <li>Technology Update</li>
                <li>Customer Success &amp; Support</li>
                <li>Partner Onboarding</li>
              </ul>
              <p>Same format as Meetup #2 - helping partners and friends grow with DBOS and their local communities.</p>
              <a href="https://luma.com/vvdhny42" target="_blank" rel="noopener noreferrer" className="btn-primary">Register on Luma</a>
            </div>
          </section>

          <section className="content-section">
            <h2>In the Press</h2>
            <div className="press-item">
              <img src="/assets/img/kilkenny-people-s.jpg" alt="Kilkenny People" className="press-item-image" />
              <p>Essaness Music's digital transformation with DBOS was featured in the Kilkenny People.</p>
              <a href="https://www.kilkennypeople.ie/news/business/long-established-kilkenny-business-hits-high-noteswith-new-digital-platform-8663863" target="_blank" rel="noopener noreferrer" className="btn-secondary">Read the article</a>
            </div>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container footer-compact">
          <div className="footer-row-1">
            <span className="footer-hours-inline"><span className="hours-label">Opening Hours (IST):</span> Mon-Thu 9:00-18:00 | Fri 9:00-12:00 | Sat-Sun Closed</span>
          </div>
          <div className="footer-row-2">
            <span className="copyright">© 2026 DBOS. Ireland (CRO Registered). All rights reserved.</span>
            <span className="footer-divider">|</span>
            <a href="/legal/terms">Terms</a>
            <a href="/legal/privacy">Privacy</a>
            <a href="/legal/cookies">Cookies</a>
            <a href="/legal/dpa">DPA</a>
            <span className="footer-divider">|</span>
            <a href="mailto:hello@dbos.world">hello@dbos.world</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Resources;
